export default {
  init() {
    // JavaScript to be fired on all pages
	$('#callbtn').on('click', function(e) {
            e.preventDefault();
            $('#callbtn-dropdown').toggle();

        });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js